import React, { useEffect, useState } from "react";
import {
  useGetGeoLocationMutation,
  useOnboardWorkshopMutation,
} from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../ThemeColors";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import { toast } from "react-toastify";
import "./WorkshopTable.scss";
import { Loader } from "react-bootstrap-typeahead";
import { useNavigate } from "react-router-dom";

const WorkshopOnboard = () => {
  const [nameValue, setNameValue] = useState("");
  const [addressValue, setAddressValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [countryValue, setCountryValue] = useState("");
  const [pincodeValue, setPincodeValue] = useState("");
  const [startTimeValue, setStartTimeValue] = useState("");
  const [adminNameValue, setAdminNameValue] = useState("");
  const [adminUsernameValue, setAdminUsernameValue] = useState("");
  const [endTimeValue, setEndTimeValue] = useState("");
  const [adminEmailValue, setAdminEmailValue] = useState("");
  const [adminPhoneValue, setAdminPhoneValue] = useState("");
  const [escalationPhoneValue, setEscalationPhoneValue] = useState("");
  // const [storedWOrkshopData, setStoreWorkshopData] = useState([]);
  const [image, setImage] = useState<any>("");
  const [gstNumber, setGstNumber] = useState("");
  const [selectedHolidays, setSelectedHolidays] = useState<any>([]);

  // ERROR
  const [nameError, setNameError] = useState(false);
  const [addressError, setAddressError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [countryError, setCountryError] = useState(false);
  const [pincodeError, setPincodeError] = useState(false);
  const [startTimeError, setStartTimeError] = useState(false);
  const [endTimeError, setEndError] = useState(false);
  const [adminNameError, setAdminNameError] = useState(false);
  const [adminUsernameError, setAdminUsernameError] = useState(false);
  const [adminEmaiError, setAdminEmaiError] = useState(false);
  const [adminPhoneError, setAdminPhoneError] = useState(false);
  const [escalationPhoneError, setEscalationPhoneError] = useState(false);
  const [geoLoctionLoader, setGeoLocationLoader] = useState(false);
  const [storeGeoLocationData, setStoreGeoLocationData] = useState<any>("");
  const [onBoardWorkshopLoader, setOnBoardWorkshopLoader] = useState(false);
  const [gstNumberError, setGstNumberError] = useState(false);

  const [geoLocationTrigger, { status }] = useGetGeoLocationMutation();
  const [onboardWorkshopTrigger, { status: onboardSTatus }] =
    useOnboardWorkshopMutation();
  // const { data: workshopData } = useGetOnboardWorkshopDataQuery({});

  const navigate = useNavigate();

  useEffect(() => {
    if (status === "pending") {
      setGeoLocationLoader(true);
    } else {
      setGeoLocationLoader(false);
    }
  }, [status]);

  useEffect(() => {
    if (onboardSTatus === "pending") {
      setOnBoardWorkshopLoader(true);
    } else {
      setOnBoardWorkshopLoader(false);
    }
  }, [onboardSTatus]);

  const holidaysList = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  // useEffect(() => {
  //     if (workshopData) {
  //         setStoreWorkshopData(workshopData?.results);
  //     }
  // }, [workshopData]);

  const imageHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedHolidays(typeof value === "string" ? value.split(",") : value);
  };

  // Function to handle mobile number input (only numbers, max 10 digits)
  const handleMobileNumberChange = (value, setter, errorSetter) => {
    // Remove any non-digit characters
    const numericValue = value.replace(/\D/g, "");

    // Limit to 10 digits
    if (numericValue.length <= 10) {
      setter(numericValue);
      // Clear error if user starts typing
      if (numericValue.length > 0) {
        errorSetter(false);
      }
    }
  };

  // Custom validation for mobile numbers
  const validateMobileNumber = (number) => {
    return number.length === 10 && /^\d{10}$/.test(number);
  };

  //    const fetchLatLngFromAddress = async (address) => {
  //     const API_KEY = "608a0d2aa204491ea25b9932de1d6602"; // Your OpenCage API key
  //     try {
  //         const response = await axios.get("https://api.opencagedata.com/geocode/v1/json", {
  //             params: {
  //                 q: address,
  //                 key: API_KEY,
  //                 limit: 1,
  //                 no_annotations: 1,
  //             },
  //         });

  //         const results = response.data.results;
  //         if (results.length === 0) {
  //             throw new Error("No results found for the address.");
  //         }

  //         const { lat, lng } = results[0].geometry;
  //         return {
  //             latitude: Number(lat.toFixed(6)),
  //             longitude: Number(lng.toFixed(6)),
  //         };
  //     } catch (error) {
  //         console.error("Geocoding error:", error.message);
  //         return {
  //             latitude: null,
  //             longitude: null,
  //         };
  //     }
  // };

  const getLocation = async (e: any) => {
    e.preventDefault();
    const locationPayload = {
      address: addressValue,
    };
    try {
      const response = await geoLocationTrigger(locationPayload);

      console.log(response, "responsnsn");
      setStoreGeoLocationData(response?.data);
      if (response?.data) {
        toast.success("Location fetched successfully");
      } else if (response?.error) {
        toast.error("unabel to find the location");
      }
    } catch (error) {}
  };

  const onboardWorkshophandler = async () => {
    // const fullAddress = `${addressValue}, ${cityValue}, ${stateValue}, ${countryValue}, ${pincodeValue}`;
    // const { latitude, longitude } = await fetchLatLngFromAddress(fullAddress);

    let hasError = false;

    if (!nameValue.trim()) {
      setNameError(true);
      hasError = true;
    } else {
      setNameError(false);
    }

    //   Address

    if (!addressValue.trim()) {
      setAddressError(true);
      hasError = true;
    } else {
      setAddressError(false);
    }

    //   City

    if (!cityValue.trim()) {
      setCityError(true);
      hasError = true;
    } else {
      setCityError(false);
    }

    //   State
    if (!stateValue.trim()) {
      setStateError(true);
      hasError = true;
    } else {
      setStateError(false);
    }

    //   Country

    if (!countryValue.trim()) {
      setCountryError(true);
      hasError = true;
    } else {
      setCountryError(false);
    }

    //   setPincodeError

    if (!pincodeValue.trim()) {
      setPincodeError(true);
      hasError = true;
    } else {
      setPincodeError(false);
    }

    //   Start time
    if (!startTimeValue.trim()) {
      setStartTimeError(true);
      hasError = true;
    } else {
      setStartTimeError(false);
    }

    //   End time
    if (!endTimeValue.trim()) {
      setEndError(true);
      hasError = true;
    } else {
      setEndError(false);
    }

    //   Admin  name

    if (!adminNameValue.trim()) {
      setAdminNameError(true);
      hasError = true;
    } else {
      setAdminNameError(false);
    }

    //  Admin usernmae

    if (!adminUsernameValue.trim()) {
      setAdminUsernameError(true);
      hasError = true;
    } else {
      setAdminUsernameError(false);
    }

    //   adminEmailValue

    if (!adminEmailValue.trim()) {
      setAdminEmaiError(true);
      hasError = true;
    } else {
      setAdminEmaiError(false);
    }

    //   adminPhoneValue - Updated validation for mobile number

    if (!adminPhoneValue.trim()) {
      setAdminPhoneError(true);
      hasError = true;
    } else if (!validateMobileNumber(adminPhoneValue)) {
      setAdminPhoneError(true);
      hasError = true;
    } else {
      setAdminPhoneError(false);
    }

    //   escalationPhoneValue - Updated validation for mobile number

    if (!escalationPhoneValue.trim()) {
      setEscalationPhoneError(true);
      hasError = true;
    } else if (!validateMobileNumber(escalationPhoneValue)) {
      setEscalationPhoneError(true);
      hasError = true;
    } else {
      setEscalationPhoneError(false);
    }

    if (!gstNumber.trim()) {
      setGstNumberError(true);
      hasError = true;
    } else {
      setGstNumberError(false);
    }

    // Stop execution if there are validation errors
    if (hasError) {
      return;
    }

    const formData = new FormData();
    formData.append("workshopName", nameValue);
    formData.append("address", addressValue);
    formData.append("city", cityValue);
    formData.append("state", stateValue);
    formData.append("country", countryValue);
    formData.append("pincode", pincodeValue);
    formData.append("startTime", startTimeValue);
    formData.append("endTime", endTimeValue);
    formData.append(
      "latitude",
      Number(storeGeoLocationData?.latitude)?.toFixed(6)
    );
    formData.append(
      "longitude",
      Number(storeGeoLocationData?.longitude)?.toFixed(6)
    );
    formData.append("workShopAdministrationName", adminNameValue);
    formData.append("workShopAdministrationUserName", adminUsernameValue);
    formData.append("workShopAdministrationEmail", adminEmailValue);
    formData.append("workShopAdministrationPhoneNumber", adminPhoneValue);
    formData.append("EscalationNumber", escalationPhoneValue);
    formData.append("holiday", selectedHolidays.join(","));
    formData.append("gstNumber", gstNumber);
    formData.append("status", "approved");
    formData.append("created_by", "Admin");
    formData.append("is_active", "true");

    if (image) {
      formData.append("workshopImage", image);
    }

    const response = await onboardWorkshopTrigger(formData);

    try {
      if (response?.data) {
        toast.success("Workshop onboarded successfully");
        setCityValue("");
        setAddressValue("");
        setAdminUsernameValue("");
        setAdminNameValue("");
        setAdminEmailValue("");
        setCountryValue("");
        setEndTimeValue("");
        setAdminPhoneValue("");
        setEscalationPhoneValue("");
        setGstNumber("");
        setNameValue("");
        setPincodeValue("");
        // setSelectedHolidays('')
        setStartTimeValue("");
        setStoreGeoLocationData("");
        setStateValue("");
        setImage("");
      } else if (response?.error && 'data' in response.error) {
        const errorData = response.error.data as Record<string, string | string[]>;
        
        // Handle all error keys including non_field_errors and any other field errors
        Object.entries(errorData).forEach(([field, errors]) => {
          if (Array.isArray(errors)) {
            errors.forEach(error => {
              if (typeof error === 'string') {
                toast.error(error);
              }
            });
          } else if (typeof errors === 'string') {
            toast.error(errors);
          }
        });
      }
    } catch (error) {
      toast.error("An error occured while onboarding the workshop");
    }
  };

  useEffect(() => {
    if (storeGeoLocationData) {
      setAddressValue(storeGeoLocationData?.formatted_address);
    }
  }, [storeGeoLocationData]);

  useEffect(() => {
    if (storeGeoLocationData?.formatted_address) {
      // Extract 6-digit PIN code
      const pinMatch =
        storeGeoLocationData?.formatted_address.match(/\b\d{6}\b/);
      if (pinMatch) setPincodeValue(pinMatch[0]);

      // Extract last part as Country
      const parts = storeGeoLocationData?.formatted_address.split(",");
      const country = parts[parts.length - 1]?.trim();
      // Remove 6-digit pincode from state, if present
      const stateRaw = parts[parts.length - 2]?.trim();
      const state = stateRaw?.replace(/\d{6}$/, '').trim();
      const city = parts[parts.length - 3]?.trim();
      if (city) setCityValue(city);

      if (state) setStateValue(state);
      if (country) setCountryValue(country);
    }
  }, [storeGeoLocationData?.formatted_address]);

  const cancelHandler = () => {
    navigate("/vehicle/workshop-listed");
  };
  return (
    <div
      style={{
        background: "white",
        height: "100%",
        boxShadow: `${selectedColor}80 0px 2px 10px 2px`,
        borderRadius: "40px",
      }}
    >
      <div
        style={{
          borderBottom: "1px solid #bfbfbf",
          fontSize: "20px",
          padding: "15px 25px",
          paddingBottom: "5px",
          color: "#626262",
          marginBottom: "20px",
          fontFamily: "Karbon-medium",
        }}
      >
        Add Workshop
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          height: "100%",
          padding: "10px 20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            // gap: "5px",
          }}
        >
          <label
            className="required"
            style={{
              fontSize: "15px",
              color: "#626262",
              font: "caption",
              padding: "0 10px",
              fontFamily: "Karbon-regular",
            }}
          >
            Name of the Workshop
          </label>
          <input
            placeholder="Workshop name"
            value={nameValue}
            onChange={(e) => setNameValue(e.target.value)}
            style={{
              borderRadius: "24px",
              padding: "10px",
              border: "0.5px solid #BFBFBF",
              background: "rgb(248, 233, 227)",
            }}
          />
          {nameError && (
            <span
              style={{
                color: "red",
                fontSize: "13px",
                paddingLeft: "10px",

                fontFamily: "Karbon-regular",
              }}
            >
              Workshop name is required
            </span>
          )}
        </div>
        {/* Address */}

        <div style={{ display: "flex", gap: "10px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              // gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              Address
            </label>
            <input
              placeholder="Address"
              value={addressValue}
              onChange={(e) => setAddressValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
            {addressError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                Address is required
              </span>
            )}
          </div>

          <div style={{ paddingTop: "20px" }}>
            <button
              style={{
                padding: "10px 25px",
                fontFamily: "Karbon-medium",
                borderRadius: "20px",
                background: `${selectedButtonBackgoundColors}`,
                color: `${selectedButtonColors}`,
                border: `1px solid ${selectedBorderColor}`,
                whiteSpace: "nowrap",
              }}
              type="button"
              onClick={getLocation}
            >
              {geoLoctionLoader ? <Loader /> : "Get location"}
            </button>
          </div>
        </div>

        {/* Codes */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              // gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              City
            </label>
            <input
              placeholder="City"
              value={cityValue}
              onChange={(e) => setCityValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
            {cityError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                City is required
              </span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              // gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              State
            </label>
            <input
              placeholder="State"
              value={stateValue}
              onChange={(e) => setStateValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
            {stateError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                State is required
              </span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              PIN Code
            </label>
            <input
              placeholder="PIN code"
              value={pincodeValue}
              onChange={(e) => setPincodeValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
            {pincodeError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                Pin Code is required
              </span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              Country
            </label>
            <input
              placeholder="Country"
              value={countryValue}
              onChange={(e) => setCountryValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
            {countryError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                Country is required
              </span>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <label style={{ fontFamily: "Karbon-regular" }}>GST Number</label>
            <input
              onChange={(e) => setGstNumber(e.target.value)}
              value={gstNumber}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
                fontFamily: "Karbon-regular",
              }}
            />
            {gstNumberError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                GST number is required
              </span>
            )}
          </div>

          <FormControl fullWidth>
            <label style={{ fontFamily: "Karbon-regular" }}>Holidays</label>
            {/* <InputLabel>Holidays</InputLabel> */}
            <Select
              multiple
              value={selectedHolidays}
              onChange={handleChange}
              input={<OutlinedInput />}
              renderValue={(selected) => selected.join(", ")}
              style={{ height: "45px" }}
              // style={{background: "rgb(248, 233, 227)"}}
            >
              {holidaysList.map((day) => (
                <MenuItem
                  key={day}
                  value={day}
                  style={{ borderRadius: "100px" }}
                >
                  <Checkbox checked={selectedHolidays.indexOf(day) > -1} />
                  <ListItemText primary={day} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* Codes End */}

        {/* WOrking hours start */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <div>
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontWeight: "600",
                fontFamily: "Karbon-regular",
              }}
            >
              Working Hours
            </label>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "10px",
              }}
            >
              <label
                className="required"
                style={{
                  fontSize: "15px",
                  color: "#626262",
                  font: "caption",
                  padding: "0 5px",
                  fontFamily: "Karbon-regular",
                }}
              >
                Start Time
              </label>
              <input
                type="time"
                value={startTimeValue}
                onChange={(e) => setStartTimeValue(e.target.value)}
                style={{
                  borderRadius: "24px",
                  padding: "10px",
                  border: "0.5px solid #BFBFBF",
                  background: "rgb(248, 233, 227)",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "10px",
              }}
            >
              <label
                className="required"
                style={{
                  fontSize: "15px",
                  color: "#626262",
                  font: "caption",
                  padding: "0 10px",
                  fontFamily: "Karbon-regular",
                }}
              >
                End Time
              </label>
              <input
                type="time"
                value={endTimeValue}
                onChange={(e) => setEndTimeValue(e.target.value)}
                style={{
                  borderRadius: "24px",
                  padding: "10px",
                  border: "0.5px solid #BFBFBF",
                  background: "rgb(248, 233, 227)",
                }}
              />
            </div>
          </div>
        </div>
        {/* WOrking hrs end */}

        {/* Workshop image */}
        <div
          style={{
            display: "flex",
            width: "100%",
            gap: "20px",
            flexDirection: "column",
          }}
        >
          <label
            className="required"
            style={{
              fontSize: "15px",
              color: "#626262",
              font: "caption",
              padding: "0 10px",
              fontFamily: "Karbon-regular",
            }}
          >
            Workshop Image
          </label>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <div
              style={{
                // border: "1px solid black",
                // borderStyle: "dotted",
                // height: "43px",
                width: "200px",
              }}
            >
              {image && (
                <img
                  src={URL.createObjectURL(image)}
                  alt="preview"
                  width={200}
                  height={200}
                />
              )}
            </div>
            <label
              htmlFor="upload-logo"
              style={{
                padding: "8px 12px",
                backgroundColor: "#007bff",
                borderRadius: "5px",
                cursor: "pointer",
                display: "inline-block",
                //   marginBottom: "20px",
                border: `1px solid ${selectedBorderColor}`,
                background: `${selectedButtonBackgoundColors}`,
                width: "100px",
                color: `${selectedButtonColors}`,
                fontFamily: "Karbon-regular",
              }}
            >
              Upload Logo
            </label>
            <span
              style={{
                fontSize: "12px",
                color: "#666",
                fontFamily: "karbon-semi",
              }}
            >
              Accepted formats: JPG, PNG, WEBP
            </span>
          </div>

          <input
            type="file"
            id="upload-logo"
            style={{ display: "none", fontFamily: "Karbon-regular" }}
            accept=".jpg,.jpeg,.png,.webp"
            onChange={imageHandler}
          />
          {/* <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                            setWorkshopImageFile(e.target.files[0])
                        }
                    /> */}
          {/* <button    style={{
                        padding: "10px 25px",
                        borderRadius: "20px",
                        background: `${selectedButtonBackgoundColors}`,
                        color: `${selectedButtonColors}`,
                        border: `1px solid ${selectedBorderColor}`,
                    }}>Upload</button> */}
        </div>
        {/* Workshop image ends */}
        <div style={{ display: "flex", gap: "20px", width: "100%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              Workshop Administrator Name
            </label>
            <input
              placeholder="Workshop administration name"
              value={adminNameValue}
              onChange={(e) => setAdminNameValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
                fontFamily: "Karbon-regular",
              }}
            />
            {adminNameError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                Name is required
              </span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              Workshop Administrator Username
            </label>
            <input
              placeholder="Workshop administrator username"
              value={adminUsernameValue}
              onChange={(e) => setAdminUsernameValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
                fontFamily: "Karbon-regular",
              }}
            />
            {adminUsernameError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                User name is required
              </span>
            )}
          </div>
        </div>
        <div style={{ display: "flex", gap: "20px", width: "100%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              Administrator Email
            </label>
            <input
              placeholder="Administrator email"
              value={adminEmailValue}
              onChange={(e) => setAdminEmailValue(e.target.value)}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
            {adminEmaiError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                Email is required
              </span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              Mobile Number
            </label>
            <input
              placeholder="Mobile number (10 digits)"
              value={adminPhoneValue}
              onChange={(e) =>
                handleMobileNumberChange(
                  e.target.value,
                  setAdminPhoneValue,
                  setAdminPhoneError
                )
              }
              maxLength={10}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
              }}
            />
            {adminPhoneError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                {adminPhoneValue.length === 0
                  ? "Mobile number is required"
                  : "Mobile number must be exactly 10 digits"}
              </span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "5px",
            }}
          >
            <label
              className="required"
              style={{
                fontSize: "15px",
                color: "#626262",
                font: "caption",
                padding: "0 10px",
                fontFamily: "Karbon-regular",
              }}
            >
              Escalation Mobile Number
            </label>
            <input
              placeholder="Escalation mobile number (10 digits)"
              value={escalationPhoneValue}
              onChange={(e) =>
                handleMobileNumberChange(
                  e.target.value,
                  setEscalationPhoneValue,
                  setEscalationPhoneError
                )
              }
              maxLength={10}
              style={{
                borderRadius: "24px",
                padding: "10px",
                border: "0.5px solid #BFBFBF",
                background: "rgb(248, 233, 227)",
                fontFamily: "Karbon-regular",
              }}
            />
            {escalationPhoneError && (
              <span
                style={{ color: "red", fontSize: "13px", paddingLeft: "10px" }}
              >
                {escalationPhoneValue.length === 0
                  ? "Escalation number is required"
                  : "Escalation number must be exactly 10 digits"}
              </span>
            )}
          </div>
        </div>

        {/* <div style={{display: "flex", flexDirection: "column", width: "100%"}}>
                    <label style={{fontSize: "15px", color: "#626262", font: "caption"}}>Service type</label>
                                       <input value={addressValue} onChange={(e) => setAddressValue(e.target.value)} style={{borderRadius: "24px", padding: "10px", border: "0.5px solid #BFBFBF"}}/>

                </div> */}

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "10px",
          }}
        >
          <button
            className="btn btn-secondary"
            style={{ borderRadius: "20px", fontFamily: "Karbon-regular" }}
            onClick={cancelHandler}
          >
            Cancel
          </button>
          <button
            style={{
              padding: "10px 25px",
              borderRadius: "20px",
              fontFamily: "Karbon-regular",

              background: `${selectedButtonBackgoundColors}`,
              color: `${selectedButtonColors}`,
              border: `1px solid ${selectedBorderColor}`,
            }}
            onClick={onboardWorkshophandler}
          >
            {onBoardWorkshopLoader ? (
              <>
                Saving <Loader />
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>

      <div>
        <iframe
          width="100%"
          height="300"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          src={`https://www.google.com/maps?q=${storeGeoLocationData?.latitude},${storeGeoLocationData?.longitude}&z=15&output=embed`}
        />
      </div>
    </div>
  );
};

export default WorkshopOnboard;
